import { RestService, Rest } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { SynchronizationUserResponseDto } from '../dtos/models';
import type { Region } from '../regions/models';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private restService = inject(RestService);
  apiName = 'Default';
  

  getUserByEmail = (email: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, SynchronizationUserResponseDto>({
      method: 'GET',
      url: '/api/app/user/user',
      params: { email },
    },
    { apiName: this.apiName,...config });
  

  getUserRegionsByEmail = (email: string, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Region[]>({
      method: 'GET',
      url: '/api/app/user/user-regions',
      params: { email },
    },
    { apiName: this.apiName,...config });
}